import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalPath, ogType = 'website', schema }: SEOHeadProps) {
  const baseUrl = 'https://ohpwbf.cn';
  const fullTitle = `${title} - 悠宝三岁`;
  const canonical = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setProperty = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setProperty('og:title', fullTitle);
    setProperty('og:description', description);
    setProperty('og:type', ogType);
    setProperty('og:url', canonical);
    setProperty('og:locale', 'zh_CN');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkEl) {
      linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute('href', canonical);

    let scriptEl: HTMLScriptElement | null = null;
    if (schema) {
      const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
      existingScripts.forEach((s) => {
        if (s.getAttribute('data-dynamic') === 'true') s.remove();
      });
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.setAttribute('data-dynamic', 'true');
      scriptEl.textContent = JSON.stringify(schema);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl) scriptEl.remove();
    };
  }, [fullTitle, description, keywords, canonical, ogType, schema]);

  return null;
}